import { connect } from 'react-redux';
import { reduxForm, formValueSelector } from 'redux-form';
import { setField, createNewConvert } from '../../actions/inventoryConverts_actions';
import ProductConvertDetail from '../../components/Inventories/productConvertDetail';

const productConvertDetail = reduxForm({
  form: 'productConvertDetail',
})(ProductConvertDetail);

const selector = formValueSelector('productConvertDetail');

function mapStateToProps(state) {
  const Convert = selector(state, 'Convert');
  const Prod1Qty = selector(state, 'Prod1Qty');
  const Prod2Qty = selector(state, 'Prod2Qty');
  return {
    Convert,
    Prod1Qty,
    Prod2Qty,
    currentProductDetail: state.products.currentProductDetail,
    detailIsLoading: state.products.detailIsLoading,
    detailError: state.products.detailError,
    fetchingRelatedProducts: state.products.fetchingRelatedProducts,
    relatedProductsFetched: state.products.relatedProductsFetched,
    relatedProductsFetchError: state.products.relatedProductsFetchError,
    inventoryConvertIsCreating: state.inventoryConverts.inventoryConvertIsCreating,
    inventoryConvertCreated: state.inventoryConverts.inventoryConvertCreated,
  };
}

export default connect(mapStateToProps, { setField, createNewConvert })(productConvertDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Inventories/productConvertDetail.jsx